import { createAction, createReducer } from '@reduxjs/toolkit';
import { IAction } from './interface/apiInterface';
import { IApurationData } from './interface/reduxInterfaces';

export const INITIAL_STATE: IApurationData = {
  isActive: false,
  isLoading: false,
  gotError: false,
  gotSuccess: false,
  totalAccountsActives: 0,
  totalAccountsPending: 0,
  totalAccountsRejected: 0,
  totalAccountsBlocked: 0,
  totalAccountsFinished: 0,
  pfMovementQuantity: 0,
  pfMovementFare: 0,
  pfMovementValueToReceive: 0,
  pjMovementQuantity: 0,
  pjMovementFare: 0,
  pjMovementValueToReceive: 0,
  escrowQuantity: 0,
  escrowFare: 0,
  escrowValueToReceive: 0,
  consignedQuantity: 0,
  consignedFare: 0,
  consignedValueToReceive: 0,
  finishedFares: 0,
  activeFares: 0,
};

export const getApurationFromApi = createAction(
  '@apurationApp/GET_APURATION_FROM_API'
);

export const gotApurationFromApi = createAction<any>(
  '@apurationApp/GOT_APURATION_FROM_API'
);

export const gotErrorFromApurationApi = createAction(
  '@apurationApp/GOT_ERROR_FROM_APURATION_API'
);

const apurationAppReducer = createReducer(INITIAL_STATE, {
  [getApurationFromApi.type]: (state) => ({
    ...state,
    isLoading: true,
    gotSuccess: false,
    gotError: false,
  }),
  [gotApurationFromApi.type]: (state, action: IAction) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    totalAccountsActives: action.payload.relatorio.total_contas.ativas,
    totalAccountsPending: action.payload.relatorio.total_contas.pendentes,
    totalAccountsRejected: action.payload.relatorio.total_contas.rejeitadas,
    totalAccountsBlocked: action.payload.relatorio.total_contas.bloqueadas,
    totalAccountsFinished: action.payload.relatorio.total_contas.encerradas,
    pfMovementQuantity:
      action.payload.relatorio.apuracao_contas_ativas.movimento_pf.qtd,
    pfMovementFare:
      action.payload.relatorio.apuracao_contas_ativas.movimento_pf.tarifa,
    pfMovementValueToReceive:
      action.payload.relatorio.apuracao_contas_ativas.movimento_pf
        .valor_receber,
    pjMovementQuantity:
      action.payload.relatorio.apuracao_contas_ativas.movimento_pj.qtd,
    pjMovementFare:
      action.payload.relatorio.apuracao_contas_ativas.movimento_pj.tarifa,
    pjMovementValueToReceive:
      action.payload.relatorio.apuracao_contas_ativas.movimento_pj
        .valor_receber,
    escrowQuantity: action.payload.relatorio.apuracao_contas_ativas.escrow.qtd,
    escrowFare: action.payload.relatorio.apuracao_contas_ativas.escrow.tarifa,
    escrowValueToReceive:
      action.payload.relatorio.apuracao_contas_ativas.escrow.valor_receber,
    consignedQuantity:
      action.payload.relatorio.apuracao_contas_ativas.consignada.qtd,
    consignedFare:
      action.payload.relatorio.apuracao_contas_ativas.consignada.tarifa,
    consignedValueToReceive:
      action.payload.relatorio.apuracao_contas_ativas.consignada.valor_receber,
    finishedFares: action.payload.relatorio.encerradas_tarifas?.nao_tarifadas,
    activeFares: action.payload.relatorio.encerradas_tarifas?.tarifadas,
  }),
  [gotErrorFromApurationApi.type]: (state) => ({
    ...state,
    isLoading: false,
    gotSuccess: false,
    gotError: true,
  }),
});

export default apurationAppReducer;
